import { NgModule } from '@angular/core';
import { SharedComponent } from './shared';

@NgModule({
	declarations: [
	SharedComponent,
	],
	exports: [
	SharedComponent
	],
	//providers: []
	providers: [SharedComponent]

/*  imports: [
    IonicPageModule.forChild(SharedComponent),
    ],*/
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/shared/shared.module.ts